import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { scaleOnClickAnim } from "../../animations";
import { ReactComponent as SettingsSvg } from "../../../assets/menu.svg";
import currencies from "../../helpers/getCurrency";

const HeaderDiv = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  p {
    text-transform: uppercase;
    font-size: 26px;
  }

  span {
    /* color: #483b3b;
    max-width: 150px;
    width: 100%;
    text-align: right;
    position: relative;
    padding: 0 5px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    font-size: 12px; */
    svg {
      margin-left: 4px;
      height: 28px;
      cursor: default;
      path {
        fill: #483b3b;
      }
    }
  }
`;

export const BalanceContainer = styled.div`
    color: #483B3B;
    font-size: 12px;
    max-width: 180px;
    width: 100%;
    text-align: right;
    position: relative;
    margin-left: 5px;
    display: flex;
    -webkit-box-align: center;
    align-items: center;
    -webkit-box-pack: end;
    justify-content: flex-end;
    flex-wrap: wrap;
    `
export const Balance = styled.span`
  overflow: hidden;
  text-overflow: ellipsis;
  margin-left: 5px;
`

export const MenuIcon = styled.div`
  display: flex;
  pointer-events: ${(p) => (p.isDisabled ? "none" : "auto")};
  svg {
    max-width: 28px;
    max-height: 28px;
    cursor: pointer;
    animation: ${(p) => (p.menuBtn ? scaleOnClickAnim : null)};
    animation-duration: 0.333s;
    animation-fill-mode: forwards;
  }
`;
export default ({
  handleAbove,
  balance,
  handleSettingsAnimation,
  floorFigure,
  audio,
  userInfo,
}) => {
  const [menuBtnAnim, setmenuBtnAnim] = useState(false);
  const [soundPlayed, setSoundPlayed] = useState(false);
  const [localBanalce, setLocalBalance] = useState(balance);

  useEffect(() => {
    balance === 0 ? setLocalBalance("0.00") : setLocalBalance(balance);
  }, [balance]);

  const { precision, curr } = userInfo;

  const setAnimation = (a, b) => {
    if (a) {
      b(false);
      clearTimeout();
    } else {
      b(true);
      setTimeout(() => {
        b(false);
      }, 500);
    }
  };

  return (
    <HeaderDiv>
      <p>Hilo</p>
      <BalanceContainer>
       <span>
        {currencies[curr]}
      </span>
      <Balance> {localBanalce && floorFigure(localBanalce, precision)}</Balance>
       </BalanceContainer>
      <MenuIcon menuBtn={menuBtnAnim} isDisabled={soundPlayed}>
        <SettingsSvg
          onClick={() => {
            setAnimation(menuBtnAnim, setmenuBtnAnim);
            audio();
            setSoundPlayed(true);
            setTimeout(() => {
              handleSettingsAnimation(true);
              handleAbove("settings");
              setSoundPlayed(false);
            }, 150);
          }}
        />
      </MenuIcon>
    </HeaderDiv>
  );
};
